import { useRef, useState } from "react";
import { Volume2, Loader2, Square } from "lucide-react";
import api from "../lib/api";

export default function SpeakButton({ text, size = 14, className = "", testId = "speak-button" }) {
  const [busy, setBusy] = useState(false);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);
  const urlRef = useRef(null);

  const cleaned = (text || "").trim();
  if (!cleaned) return null;

  const stop = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
    if (urlRef.current) {
      URL.revokeObjectURL(urlRef.current);
      urlRef.current = null;
    }
    setPlaying(false);
    setBusy(false);
  };

  const play = async () => {
    if (playing || busy) { stop(); return; }
    setBusy(true);
    try {
      const res = await api.post("/tts", { text: cleaned, voice: "nova" }, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      urlRef.current = url;
      const audio = new Audio(url);
      audioRef.current = audio;
      audio.onended = stop;
      audio.onerror = stop;
      setBusy(false);
      setPlaying(true);
      await audio.play();
    } catch (e) {
      console.error("TTS error", e);
      stop();
    }
  };

  return (
    <button type="button" onClick={play} aria-label="Listen"
      data-testid={testId}
      className={`inline-flex items-center justify-center w-7 h-7 rounded-full shrink-0 transition ${playing ? "bg-amber-300 text-slate-900" : "bg-sky-100 hover:bg-sky-200 text-sky-700"} ${className}`}>
      {busy ? <Loader2 size={size} className="animate-spin" strokeWidth={2.5}/>
        : playing ? <Square size={size - 2} strokeWidth={3} fill="currentColor"/>
        : <Volume2 size={size} strokeWidth={2.5}/>}
    </button>
  );
}
